import { T } from './actionTypes';

// Higher-order reducer
const routerReducer = (reducer, locationChange) => (state, action) =>
  action.type === T.LOCATION_CHANGE
    ? locationChange(state || reducer(state, action), action)
    : reducer(state, action);

export default routerReducer;
